// extracted by mini-css-extract-plugin
export var alternate = "_1v-j";
export var black = "_1v-6";
export var blue = "_1v-f";
export var blueLight = "_1v-e";
export var brand = "_1v-8";
export var darkMode = "_1v-b";
export var error = "_1v-a";
export var gray = "_1v-5";
export var grayBlue = "_1v-d";
export var iconWrapper = "_1v-3";
export var inactive = "_1v-7";
export var indigo = "_1v-g";
export var orange = "_1v-i";
export var pink = "_1v-h";
export var primary = "_1v-0";
export var purple = "_1v-9";
export var success = "_1v-4";
export var warning = "_1v-c";
export var white = "_1v-1";
export var whiteSuccess = "_1v-2";